import React from 'react';
import PropTypes from "prop-types";
import {connectSearchBox} from 'react-instantsearch-dom';
import debounce from 'lodash/debounce';
import SearchBox from "./SearchBox";

class SearchBoxContainer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props.currentRefinement
        };

        this.debouncedRefine = debounce(() => {
            this.props.refine(this.state.value)
        }, props.debounceDelay);

        this.inputRef = React.createRef();
    }

    focusInput = () => {
        this.inputRef && this.inputRef.current.focus();
    };

    clearQueryString = () => {
        let url = new URL(window.location.toString());
        let searchParams = url.searchParams;

        searchParams.delete('q');
        url.search = searchParams.toString();

        window.history.replaceState({}, '', url.toString());
    };

    componentDidUpdate = (prevProps) => {
        if (this.props.searchIn !== prevProps.searchIn) {
            this.focusInput();
        }
    };

    handleChange = event => {
        this.setState({value: event.target.value}, this.debouncedRefine);
    };

    handleClickClear = event => {
        event.preventDefault();

        this.setState({value: ''}, () => {
            this.debouncedRefine();
            this.clearQueryString();
            this.focusInput();
        });
    };

    render() {
        return (
            <SearchBox
                inputRef={this.inputRef}
                value={this.state.value}
                onChange={this.handleChange}
                onClickClear={this.handleClickClear}
            />
        )
    }
}

SearchBoxContainer.propTypes = {
    debounceDelay: PropTypes.number,
    // Injected by connectSearchBox
    currentRefinement: PropTypes.string,
    defaultRefinement: PropTypes.string,
    refine: PropTypes.func.isRequired,
};

SearchBoxContainer.defaultProps = {
    debounceDelay: 300,
    currentRefinement: '',
    defaultRefinement: '',
};

export default connectSearchBox(SearchBoxContainer);
